(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-benefits"] && !Shopify.designMode) return;
  try {
    
  /* Benefits accordion: only one item open at a time.
     Works across all browsers (no reliance on the native
     <details name> grouping). */
  (function(){
    document.querySelectorAll('.tns-benefits .tns-acc').forEach(function(acc){
      var items = acc.querySelectorAll('.tns-acc__item');
      items.forEach(function(item){
        item.addEventListener('toggle', function(){
          if(!item.open) return;
          items.forEach(function(other){
            if(other !== item && other.open) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-dosage-calculator"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function boot(root){
      if(!root || root.dataset.dcReady==='1') return;
      root.dataset.dcReady='1';

      var state={ strength:1000, water:2, dose:50, syringe:0.5 };

      function $(id){return root.querySelector('#'+id);}
      function fmt(n,d){return Number(n).toFixed(d);}

      function segInit(id){
        var seg=$(id); if(!seg) return;
        seg.addEventListener('click',function(e){
          var b=e.target.closest('button'); if(!b) return;
          seg.querySelectorAll('button').forEach(function(x){x.classList.remove('is-on');});
          b.classList.add('is-on');
          state[seg.dataset.name]=parseFloat(b.dataset.v);
          render();
        });
      }
      segInit('dc-syringe');

      var STR=[100,250,500,1000];
      var strengthEl=$('dc-strength');
      var stops=root.querySelectorAll('.dc-stops span');
      if(stops[3]) stops[3].classList.add('is-on');
      strengthEl.addEventListener('input',function(){
        var i=parseInt(strengthEl.value,10);
        state.strength=STR[i];
        stops.forEach(function(s,k){ s.classList.toggle('is-on', k===i); });
        render();
      });

      var water=$('dc-water'), dose=$('dc-dose');
      water.addEventListener('input',function(){state.water=parseFloat(water.value);render();});
      dose.addEventListener('input',function(){state.dose=parseFloat(dose.value);render();});

      function drawSyringe(units, maxUnits){
        var x0=36, w=328; // barrel inner
        var frac=Math.max(0,Math.min(1,units/maxUnits));
        var fillW=w*frac;
        $('dc-fill').setAttribute('width', fmt(fillW,1));
        var edge=x0+fillW;
        $('dc-plunger').setAttribute('x', fmt(edge-6,1));
        root.querySelector('#dc-marker line').setAttribute('x1', fmt(edge,1));
        root.querySelector('#dc-marker line').setAttribute('x2', fmt(edge,1));
        // ticks
        var step = maxUnits<=30?5 : (maxUnits<=50?10:20);
        var ticks='';
        for(var u=0; u<=maxUnits; u+=step){
          var tx=x0 + w*(u/maxUnits);
          ticks += '<line x1="'+fmt(tx,1)+'" y1="46" x2="'+fmt(tx,1)+'" y2="'+(u%(step*2)===0?'60':'54')+'" stroke-width="1.5"/>';
          if(u%(step* (maxUnits>50?2:1))===0){
            ticks += '<text x="'+fmt(tx,1)+'" y="112" font-size="11" text-anchor="middle" stroke="none">'+u+'</text>';
          }
        }
        $('dc-ticks').innerHTML=ticks;
      }

      function render(){
        var C = state.strength / state.water;            // mg/ml
        var V = state.dose / C;                            // ml
        var units = V*100;                                 // U-100
        var mgPerUnit = C/100;
        var dosesPerVial = Math.floor(state.strength / state.dose);
        var maxUnits = state.syringe*100;                  // 30/50/100

        $('dc-v-strength').textContent = state.strength+' mg';
        $('dc-v-water').textContent = fmt(state.water,1)+' ml';
        $('dc-v-dose').textContent = state.dose+' mg';

        $('dc-r-units').textContent = (units%1===0)? units : fmt(units,1);
        $('dc-r-ml').textContent = fmt(V,2)+' ml · '+fmt(mgPerUnit,1)+' mg per unit';
        $('dc-r-conc').textContent = (C%1===0)? C : fmt(C,1);
        $('dc-r-doses').textContent = dosesPerVial;
        $('dc-syr-note').textContent = 'Fill to the highlighted mark on a '+fmt(state.syringe,1)+' ml ('+maxUnits+'-unit) syringe.';

        var over = units>maxUnits;
        drawSyringe(over?maxUnits:units, maxUnits);

        var flag=$('dc-r-flag');
        if(over){
          flag.style.display='flex';
          $('dc-r-flag-text').textContent = 'That dose needs '+fmt(units,0)+' units — more than this syringe holds. Add more water, pick a bigger syringe, or split the dose.';
        } else { flag.style.display='none'; }
      }

      render();
    }
    function initAll(){ document.querySelectorAll('.tns-dc-section .dc-root').forEach(boot); }
    if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initAll); }
    else { initAll(); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-experience"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.tnsXpReady === '1') return;
      root.dataset.tnsXpReady = '1';

      var steps = root.querySelectorAll('[data-tns-xp-step]');
      var panels = root.querySelectorAll('[data-tns-xp-panel]');
      var shots = root.querySelectorAll('[data-tns-xp-shot]');
      if (!steps.length) return;

      var current = -1;

      function setActive(i) {
        if (i === current) return;
        current = i;
        [panels, shots].forEach(function (group) {
          for (var n = 0; n < group.length; n++) {
            group[n].classList.toggle('is-active', Number(group[n].dataset.tnsXpPanel || group[n].dataset.tnsXpShot) === i);
          }
        });
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(Number(entry.target.dataset.tnsXpStep));
        });
      }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });

      steps.forEach(function (step) { io.observe(step); });

      setActive(0);
    }

    function boot() {
      document.querySelectorAll('[data-tns-xp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.tns-hero-section').forEach(function(root){
      const slides = root.querySelector('.tns-slides');
      const dots = root.querySelectorAll('.tns-carousel__dot');
      const prev = root.querySelector('.tns-carousel__arrow--prev');
      const next = root.querySelector('.tns-carousel__arrow--next');
      const carousel = root.querySelector('.tns-carousel');
      if(!slides || dots.length === 0) return;
      const total = dots.length;
      const autoplay = root.dataset.autoplay === 'true';
      const interval = (parseInt(root.dataset.interval, 10) || 7) * 1000;
      let i = 0, timer;
      const go = (n) => {
        i = (n + total) % total;
        slides.style.transform = `translateX(-${i*100}%)`;
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      };
      const tick = () => { if(!autoplay) return; clearInterval(timer); timer = setInterval(()=>go(i+1), interval); };
      dots.forEach(d => d.addEventListener('click', e => { go(parseInt(e.currentTarget.dataset.i,10)); tick(); }));
      if(prev) prev.addEventListener('click', () => { go(i-1); tick(); });
      if(next) next.addEventListener('click', () => { go(i+1); tick(); });
      carousel.addEventListener('mouseenter', () => clearInterval(timer));
      carousel.addEventListener('mouseleave', tick);
      tick();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
